import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const ContactInfo = () => {
  const { t } = useLanguage();

  return (
    <div>
      <span className="inline-block text-accent font-semibold mb-4 uppercase tracking-wider text-sm">{t("contact.label")}</span>
      <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">{t("contact.title")}</h2>
      <p className="text-muted-foreground text-lg mb-8 leading-relaxed">{t("contact.description")}</p>

      <div className="space-y-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center flex-shrink-0"><MapPin className="w-6 h-6 text-primary-foreground" /></div>
          <div>
            <h3 className="font-semibold text-foreground mb-1">{t("contact.address")}</h3>
            <p className="text-muted-foreground">ul. Tysiąclecia 38<br />62-002 Golęczewo, {t("contact.country")}</p>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center flex-shrink-0"><Phone className="w-6 h-6 text-primary-foreground" /></div>
          <div>
            <h3 className="font-semibold text-foreground mb-1">{t("contact.phone")}</h3>
            <a href="tel:+48502625857" className="text-muted-foreground hover:text-accent transition-colors">+48 502 625 857</a>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center flex-shrink-0"><Mail className="w-6 h-6 text-primary-foreground" /></div>
          <div>
            <h3 className="font-semibold text-foreground mb-1">{t("contact.email")}</h3>
            <a href="mailto:biuro@gendera-service.pl" className="text-muted-foreground hover:text-accent transition-colors">biuro@gendera-service.pl</a>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center flex-shrink-0"><Clock className="w-6 h-6 text-primary-foreground" /></div>
          <div>
            <h3 className="font-semibold text-foreground mb-1">{t("contact.hours")}</h3>
            <p className="text-muted-foreground">{t("contact.hours.weekdays")}<br />{t("contact.hours.weekend")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
